import _ from 'lodash'

export const serviceCodes = [
  16, 20, 32, 17, 18, 39, 37, 38, 40, 13, 9, 8, 46, 27
]

export const mappings = () => {
  var mapper = {
    "f": "а", "F": "А",
    ",": "б", "<": "Б",
    "d": "в", "D": "В",
    "u": "г", "U": "Г",
    "l": "д", "L": "Д",
    "t": "е", "T": "Е",
    ";": "ж", ":": "Ж",
    "p": "з", "P": "З",
    "b": "и", "B": "И",
    "q": "й", "Q": "Й",
    "r": "к", "R": "К",
    "k": "л", "K": "Л",
    "v": "м", "V": "М",
    "y": "н", "Y": "Н",
    "j": "о", "J": "О",
    "g": "п", "G": "П",
    "h": "р", "H": "Р",
    "c": "с", "C": "С",
    "n": "т", "N": "Т",
    "e": "у", "E": "У",
    "a": "ф", "A": "Ф",
    "[": "х", "{": "Х",
    "w": "ц", "W": "Ц",
    "x": "ч", "X": "Ч",
    "i": "ш", "I": "Ш",
    "o": "щ", "O": "Щ",
    "]": "ъ", "}": "Ъ",
    "s": "ы", "S": "Ы",
    "m": "ь", "M": "Ь",
    "'": "э", "\"": "Э",
    ".": "ю", ">": "Ю",
    "z": "я", "Z": "Я"
  }

  if (navigator.platform.toLowerCase().indexOf('mac') > -1) {
    mapper['\\'] = 'ё'
    mapper['|'] = 'Ё'
  }
  else {
    mapper['`'] = 'ё'
    mapper['~'] = 'Ё'
  }

  return mapper
}

const symbolMap = mappings();

export const transliterate = (word) => {
  return _.map(word.split(''), (char) => symbolMap[char] || char).join('')
}
